// Basic Accessibility Fixes
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('br, hr').forEach(element => {
  element.setAttribute('aria-hidden', 'true');
});

  const testimonialHeader = document.querySelector('h1.testimonial-header');
  if (testimonialHeader && testimonialHeader.textContent.trim() === '') {
    testimonialHeader.remove();
  }

});

// span to h1 
document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        const span = document.querySelector(".jQDaRw span");

        if (!span) return;

        const h1 = document.createElement("h1");

        for (let attr of span.attributes) {
            h1.setAttribute(attr.name, attr.value);
        }

        h1.innerHTML = span.innerHTML;

        span.parentNode.replaceChild(h1, span);
    }, 500); 
});

document.addEventListener("DOMContentLoaded", function () {
    const span = document.querySelector("span.sc-eZKLwX.jcZVJU.pf-12_, span.sc-bOQUxc.quwHz.pf-18_");

    if (!span) return;

    const h1 = document.createElement("h1");

    for (let attr of span.attributes) {
        h1.setAttribute(attr.name, attr.value);
    }

    h1.innerHTML = span.innerHTML;

    span.parentNode.replaceChild(h1, span);
});

// H3 to h2 
document.addEventListener("DOMContentLoaded", function () {
    const h3Elements = document.querySelectorAll('h3[data-pf-type="ProductTitle"]');

    h3Elements.forEach(function (h3) {
        const h2 = document.createElement("h2");

        for (let attr of h3.attributes) {
            h2.setAttribute(attr.name, attr.value);
        }

        h2.innerHTML = h3.innerHTML;

        h3.parentNode.replaceChild(h2, h3);
    });
});

document.querySelectorAll('span.sc-bOQUxc.quwHz.pf-12_').forEach(el => {
  // Create new h1 element
  const h1 = document.createElement('h1');

  // Copy inner content
  h1.innerHTML = el.innerHTML;

  // Copy all attributes
  for (const attr of el.attributes) {
    h1.setAttribute(attr.name, attr.value);
  }

  // Replace the original span with the new h1
  el.replaceWith(h1);
});


document.addEventListener("DOMContentLoaded", () => {
  const accessBtn = document.getElementById("accessmenubt");
  const sidebarMenu = document.getElementById("sidebar-menu");
  const closeBtn = document.getElementById("closemenubt");

  // Ensure sidebar can be focused
  sidebarMenu.setAttribute("tabindex", "-1");

  // When user clicks the access button → focus moves to sidebar
  accessBtn.addEventListener("click", () => {
    setTimeout(() => {
      sidebarMenu.focus();
    }, 500); // allow UI to update
  });

  // When user presses Escape inside the menu → return focus to access button
  sidebarMenu.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      setTimeout(() => {
        accessBtn.focus();
      }, 500);
    }
  });

  // When user clicks the close button → return focus to access button
  closeBtn.addEventListener("click", () => {
    setTimeout(() => {
      accessBtn.focus();
    }, 500);
  });
});

// External Links Warning
document.addEventListener('DOMContentLoaded', () => {
  const excludedLinks = [
    'https://www.facebook.com/sparitual',
    'https://twitter.com/sparitual',
    'https://instagram.com/sparitualist'
  ];

  const isExternalLink = (url) => {
    try {
      const linkHost = new URL(url).hostname;
      const currentHost = window.location.hostname;
      return linkHost && linkHost !== currentHost;
    } catch {
      return false;
    }
  };

  const enhanceExternalLinks = () => {
    const links = document.querySelectorAll('a');

    links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href || !isExternalLink(href) || excludedLinks.includes(href)) return;

      // Open in new tab
      link.setAttribute('target', '_blank');

      // Set aria-label on link
      const linkText = link.textContent.trim();
      link.setAttribute('aria-label', `${linkText}, This link will open in a new tab`);

      // Update image alt text
      const img = link.querySelector('img, svg');
      if (img) {
        const altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, This link will open in a new tab`
          : 'This link will open in a new tab';
        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  const enhanceContactLinks = () => {
    const contactLinks = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');

    contactLinks.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();

      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email Address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };

  // Initialize enhancements
  enhanceExternalLinks();
  enhanceContactLinks();
});

// Accessible Search 
document.addEventListener("DOMContentLoaded", function () {
    const searchContainer = document.querySelector("div#Search");
    const searchButton = document.querySelector("a#search-button");
    const searchCloseButton = document.querySelector("button#search-close-bt");

    // Function to move focus after 1 second
    function redirectFocusWithDelay() {
        setTimeout(() => {
            searchButton.focus();
        }, 500); // 1000 ms = 1 second
    }

    // ESC key inside search container
    searchContainer.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
            event.preventDefault();
            redirectFocusWithDelay();
        }
    });

    // Click on close button
    searchCloseButton.addEventListener("click", function () {
        redirectFocusWithDelay();
    });
});

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const input1 = document.getElementById("compact-cfc2d55c-7f7e-46c5-adf0-d2ac7f481751");
    const input2 = document.getElementById("compact-a1707e6a-3a72-4714-b5c3-1e18789408d5");

    if (input1) {
      input1.setAttribute("aria-label", "product label");
    }

    if (input2) {
      input2.setAttribute("aria-label", "product label");
    }
  }, 1000); // 1 second delay
});